module.exports = __webpack_public_path__ + "static/index/img/baikal-902.731e23bf.jpg";